export default {
  BOARD_LOAD: 'BOARD_LOAD',
  BOARD_LOADED: 'BOARD_LOADED',
  GAME_RESET: 'GAME_RESET',
  GAME_RANDOM: 'GAME_RANDOM',
  TILE_SELECT: 'TILE_SELECT'
};



// WEBPACK FOOTER //
// ./src/actions/index.js